import { WaveOneAddressPointsAttributionResponse } from "@/app/api/wave_one_points/route"
import { useWallet } from "@/components/Providers/WalletProvider"

import { useQuery } from "@tanstack/react-query"
import axios from "axios"

const getWaveOneAddressPointsAttribution = async (
  address: string | undefined
): Promise<WaveOneAddressPointsAttributionResponse> => {
  const { data: addressPointsAttribution } = await axios.get(`/api/wave_one_points?address=${address}`)
  return addressPointsAttribution
}

export default function useWaveOneAddressPointsAttribution() {
  const { address } = useWallet()
  return useQuery({
    queryKey: ["wave_one_points", address],
    queryFn: () => getWaveOneAddressPointsAttribution(address),
    enabled: !!address,
    refetchOnWindowFocus: false,
  })
}
